import { lazy } from "react";
import { Navigate } from "react-router-dom";
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';

const AnnouncementList = lazy(() => import("../components/announcementList"));
const AnnouncementCreate = lazy(() => import("../components/announcementCreate"));
const AnnouncementView = lazy(() => import("../components/announcementView"));

const announcementRoute = [

  {
    icon: NotificationImportantIcon,
    name: "Announcement",
    link: "/announcement",
    path: "announcement",
    index: 21,
    element: <AnnouncementList />,
    superAdminView: false,
    permission: "Announcement-Read",
  },
  {
    path: "announcement/create",
    element: <AnnouncementCreate />,
  },
  {
    path: "announcement/:id",
    element: <AnnouncementCreate />,
  },
  {
    path: "announcement/view/:id",
    element: <AnnouncementView />,
  },
  {
    path: "",
    element: <Navigate to="/announcement" replace />,
  },
  // ],
];
export default announcementRoute;
